import { Alert } from '@airtm/airtm-ui';
import { useTranslation, Trans } from 'react-i18next';
import { getTosLink, LOCAL_STORAGE } from '@constants';
import { useStoredState } from 'utils/hooks';

const CookieBanner = function () {
  const { i18n, t } = useTranslation(['ALERTS', 'STATIC']);
  const [skipBanner, setSkipBanner] = useStoredState(LOCAL_STORAGE.SKIP_COOKIE_BANNER, false);

  if (skipBanner) return null;

  return (
    <div className="fixed-bottom">
      <Alert
        className="mb-0 rounded-0 p-3"
        title={t('ALERTS:ENTERPRISE_COOKIE_BANNER_TITLE')}
        variant="informative"
        btnLabel={t('STATIC:ACCEPT')}
        btnAction={() => setSkipBanner(true)}
        altLabel={t('STATIC:READ_MORE')}
        altAction={() => window.open(getTosLink(i18n.language), '_blank', 'noopener noreferrer')}
      >
        <Trans i18nKey="ALERTS:ENTERPRISE_COOKIE_BANNER_MESSAGE" />
      </Alert>
    </div>
  );
};

export default CookieBanner;
